import React, { useEffect } from "react";
import { Form, Button, Input, message, Select, Card, Typography, Space } from "antd";
import { SaveOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { apiClient } from "../../../shared/api/AllApi";
import { invalidateCatalog } from "../../../hooks/useCatalogData";

const { Title } = Typography;
const { Option } = Select;

const UpdateCustomer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [form] = Form.useForm();

  useEffect(() => {
    apiClient.get(`/customers/${id}`)
      .then((res) => {
        const c = res.data || {};
        form.setFieldsValue({ name: c.name || "", type: c.type || "", phone_number: c.phone_number || "", email: c.email || "" });
      })
      .catch(() => message.error(t("fetchError")));
  }, [id, form, t]);

  const onFinish = async (values) => {
    try {
      await apiClient.put(`/customers/${id}`, values);
      invalidateCatalog("customers");
      message.success(t("successMessage"));
      navigate("/GetCustomer");
    } catch (error) {
      message.error(error?.response?.data?.message || t("errorMessage"));
    }
  };

  return (
    <div className="page-container">
      <div className="page-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Title level={3} style={{ margin: 0 }}>{t("edit")} {t("customers")}</Title>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/GetCustomer")}>{t("cancel")}</Button>
      </div>
      <Card className="form-card">
        <Form form={form} layout="vertical" onFinish={onFinish} requiredMark scrollToFirstError style={{ maxWidth: 640 }}>
          <Form.Item name="name" label={t("name")} rules={[{ required: true }]}>
            <Input placeholder={t("enterName")} size="large" />
          </Form.Item>
          <Form.Item name="email" label={t("email")} rules={[{ type: "email", message: t("invalidEmail") }]}>
            <Input placeholder={t("enterEmail")} size="large" />
          </Form.Item>
          <Form.Item name="phone_number" label={t("phone")}>
            <Input placeholder={t("enterPhone")} size="large" />
          </Form.Item>
          <Form.Item name="type" label={t("type")}>
            <Select placeholder={t("selectType")} size="large" allowClear>
              <Option value="Company">{t("company")}</Option>
              <Option value="Individual">{t("individual")}</Option>
              <Option value="Organization">{t("organization")}</Option>
            </Select>
          </Form.Item>
          <Form.Item style={{ marginTop: 8 }}>
            <Space>
              <Button type="primary" htmlType="submit" icon={<SaveOutlined />} size="large">{t("submit")}</Button>
              <Button size="large" danger onClick={() => navigate("/GetCustomer")}>{t("cancel")}</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default UpdateCustomer;
